module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_honor_magicbook_de-6e93f71d2926b80256ad317dfb8a77e9.jpg";